<template>
  <div class="full-height">
    <AppHeader />
    <section>
      <div class="container">
        <div class="columns">
          <div class="column is-narrow" v-if="menuModel.length > 1">
            <cnc-menu :models="menuModel" title="Accounts" />
          </div>
          <div class="column">
            <h1 class="title" v-if="id">Account Number: {{ id }}</h1>
            <cnc-query
              :query="accountInfoQuery.query"
              :vars="accountInfoQuery.vars"
              :key="JSON.stringify(accountInfoQuery.vars)"
            >
              <template v-slot="{ model }">
                <div class="columns">
                  <div class="column">
                    <div class="card">
                      <header class="card-header">
                        <h1 class="card-header-title">Account Info</h1>
                      </header>
                      <div class="card-content">
                        <div class="content">
                          <p v-if="model.firstName">
                            <span>
                              <i class="fas fa-user"></i>
                              <b>User Name:</b>
                              {{ model.firstName }} {{ model.lastName }}
                            </span>
                          </p>
                          <p>
                            <span>
                              <i class="fas fa-hashtag"></i>
                              <b>Account Number:</b>
                              {{ id }}
                            </span>
                          </p>
                          <p v-if="model.company">
                            <span>
                              <i class="fas fa-building"></i>
                              <b>Company:</b>
                              {{ model.company }}
                            </span>
                          </p>
                          <p>
                            <span>
                              <i class="fas fa-info"></i>
                              <b>Status:</b>
                              {{ model.activated ? "Active" : "Deactivated" }}
                            </span>
                          </p>
                          <p v-if="model.email">
                            <span>
                              <i class="fas fa-envelope"></i>
                              <b>Email:</b>
                              {{ model.email }}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="card">
                      <header class="card-header">
                        <h1 class="card-header-title">Forwarding</h1>
                      </header>
                      <div class="card-content">
                        <div class="content">
                          <cnc-form
                            :key="id"
                            schema="Account"
                            :id="id"
                            :fieldLabels="{ forwardTo: 'Forward Number' }"
                            :fields="['forwardTo']"
                          />

                          <div class="message-body forwardTo-message">
                            <strong :class="{ warning: !!model.forwardTo }"
                              >All incoming messages will be forwarded to the
                              number provided. No Find-me-follow-me rules will
                              be applied.</strong
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </cnc-query>

            <h2 class="title">DID Numbers</h2>
            <cnc-schema-list
              :key="$route.params.accountId"
              schema="DidNumber"
              :columnLabels="{ id: 'DID Number', name: 'Name' }"
              :columns="['id', 'name']"
              emptyMessage="No DID numbers have been registered yet."
              :sort="[{ path: 'id', direction: 'ASCENDING' }]"
              :config="config"
            />

            <h2 class="title">Find-Me-Follow-Me</h2>
            <cnc-schema-list
              :key="id + 'A'"
              schema="FindMeFollowMe"
              :columnLabels="{
                number: 'Account Number',
                startSec: 'Start',
                endSec: 'End',
              }"
              :columns="['number', 'name', 'startSec', 'endSec']"
              emptyMessage="No Find-Me-Follow-Me mapping have been registered yet."
              :sort="[{ path: 'startSec', direction: 'ascending' }]"
            />
          </div>
        </div>
      </div>
    </section>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "../components/AppHeader";
import AppFooter from "../components/AppFooter";

export default {
  name: "home",
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      model: null,
      config: {
        fields: {
          id: {
            link(model) {
              return {
                name: "PSTN-update",
                params: { didNumberId: model.id },
              };
            },
          },
        },
      },
      changedValue: null,
    };
  },
  computed: {
    accountInfoQuery() {
      return {
        query: `query($id: ID!) {
            model: AccountOne(id: $id ) {
              company
              email
              activated
              firstName
              lastName
              forwardTo
            }
          }`,
        vars: { id: this.$route.params.accountId },
      };
    },
    id() {
      return this.$route.params.accountId;
    },
    menuModel() {
      let menuModel = [];
      if (this.model === null) return menuModel;
      let i = 1;
      for (const model of this.model) {
        menuModel.push({
          id: i,
          parentId: null,
          label: model.id + " - " + model.firstName,
          route: {
            name: "Account-update",
            params: {
              accountId: model.id,
            },
          },
          order: i,
        });
        i = i + 1;
      }
      return menuModel;
    },
  },
  async mounted() {
    const result = await this.$cnc.load({
      query: `query {
          model:AccountMany(options: { sort: [{path: "id", direction: ASCENDING}]}) {
             id
             firstName
          }
        }`,
    });
    if (result.model) {
      this.model = result.model.sort(
        (m1, m2) => parseInt(m1.id, 10) - parseInt(m2.id, 10)
      );
    }
  },
};
</script>

<style scoped>
h2 {
  margin-top: 1em;
}
.card {
  height: 100%;
}
.svg-inline--fa {
  width: 25px;
}
.full-height {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.forwardTo-message {
  margin-top: 1em;
}
.warning {
  color: red;
}
.column {
  margin-left: 4px;
  margin-right: 4px;
}
</style>
